<template>
  <div class="row p-1">
    <!--Campo de Datas-->
    <div class="col-sm-12 text-left mt-1 row">
      <base-input class="col-sm-6 col-12 text-left" :class="block.data_inicial === true ? 'has-danger' : ''"
        label="Data Inicial" type="date" v-model="payload.data_inicial">
      </base-input>

      <base-input class="col-sm-6 col-12 text-left" :class="block.data_final === true ? 'has-danger' : ''"
        label="Data Final" type="date" v-model="payload.data_final">
      </base-input>
    </div>

    <!--Campo Funcionario-->
    <div class="col-sm-12 text-left mt-1 form-group has-label row">
      <label>
        Funcionário
      </label>
      <autocomplete class="col-12" :search="carregarFuncionario" placeholder="Selecionar Funcionário"
        aria-label="Selecionar Funcionário" :get-result-value="procurarFuncionario" @submit="selecionarFuncionario">
      </autocomplete>
    </div>

    <!--Campo Posto e Departamento-->
    <div class="col-sm-12 text-left mt-1">
      <div class="d-flex">
        <div class="mr-3 form-group text-left has-label">
          <label>
            Posto de Trabalho
          </label>
          <el-select class="select-success mb-3 pagination-select" placeholder="Todos os postos de trabalho"
            v-model="payload.id_posto" :disabled="block.posto">
            <el-option v-for="item in postos" :key="item.id" class="select-success" :label="item.local"
              :value="item.id">{{ item.local }}</el-option>
          </el-select>
        </div>

        <div class="mr-3 form-group text-left has-label">
          <label>
            Departamento
          </label>
          <el-select class="select-success mb-3 pagination-select" placeholder="Todos os departamentos"
            v-model="payload.id_departamento" :disabled="block.departamento">
            <el-option v-for="item in departamentos" :key="item.id" class="select-success" :label="item.descricao"
              :value="item.id">{{ item.descricao }}</el-option>
          </el-select>
        </div>
      </div>
    </div>

    <span class="text-info">ATENÇÃO: Para a opção TODOS, a geração e visualização em tela tem limite de 1 mês.</span>

    <!--Buttons-->
    <div class="col-sm-12 text-center mt-1 row">
      <base-button type="success" class="btn_ text-center col-sm-3 col-12 animation-on-hover"
        @click="pesquisar()">Pesquisar</base-button>
      <base-button v-if="btEnviarEmail" type="success" class="btn_ text-center col-sm-4 col-12 animation-on-hover"
        @click="dialogEmails = true">Enviar
        por Email</base-button>
      <base-button type="warning" class="btn_ text-center col-sm-3 col-12 animation-on-hover"
        @click="limparFiltro">Limpar</base-button>
    </div>

    <modal :show.sync="dialogEmails">
      <template slot="header">
        <h4 class="modal-title" id="exampleModalLabel">
          Para quem deseja enviar??
        </h4>
      </template>
      <div class="row">
        <span class="col-12 text-left">Exemplo: nome@email.com; novo@email.com</span>
        <div class="col-md-12 pr-md-1 text-left">
          <base-input class="text-left" :class="block.emails === true ? 'has-danger' : ''" type="text" v-model="emails"
            placeholder="">
          </base-input>
        </div>
      </div>
      <template slot="footer">
        <div class="w-100 d-flex justify-content-end">
          <base-button type="success" @click="enviarEmail">Enviar</base-button>
        </div>
      </template>
    </modal>

    <!--Fim-->
  </div>
</template>

<script>
import { BaseInput } from "./index";
import { Select, Option } from "element-ui";
import Modal from "@/components/Modal.vue";
import Fuse from "fuse.js";
import moment from "moment";
import swal from "sweetalert2";


export default {
  name: "BaseFiltroPonto",
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    BaseInput,
    Modal
  },
  props: {
    periodo: {
      de: String,
      ate: String
    },
    btEnviarEmail: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      dialogEmails: false,
      dadosUsuario: "",
      fuseSearch: null,
      emails: "",
      block: {
        departamento: true,
        posto: true,
        funcionario: true,
        emails: "",
        data_final: "",
        data_inicial: ""
      },
      departamentos: [],
      postos: [],
      imagens: [],
      funcionarios: [],
      payload: {
        data_final: "",
        data_inicial: "",
        id_departamento: "",
        id_posto: "",
        id_funcionario: "",
        emails: [""],
        empresasRestrincao: [],
        idUsuario: ""
      },
    };
  },
  mounted() {
    this.carregarDadosUsuario();
    this.listarDepartamentos();
    this.listarPostos();
    this.listarFuncionarios();
  },
  methods: {
    enviarEmail() {
      if (this.validarCampos(true)) {
        this.dialogEmails = false;
        this.payload.setDB = this.$cookies.get("db");
        this.payload.id_empregador = this.$cookies.get("idEmpregador");

        if (this.dadosUsuario) {
          this.payload.idUsuario = this.dadosUsuario.id;
        }

        this.$cookies.set("emails", this.emails);
        this.$emit("enviarEmail", this.payload);
      } else {
        if (this.block.emails) {
          this.dialogEmails = true;
        } else {
          this.dialogEmails = false;
        }
      }
    },
    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },
    moment: function (data) {
      return moment(data);
    },
    carregarDadosUsuario() {
      this.dadosUsuario = this.$cookies.get("usuario") || null;
      if (this.periodo.de && this.periodo.ate) {
        this.payload.data_inicial = this.periodo.de;
        this.payload.data_final = this.periodo.ate;
      }
    },
    selecionarFuncionario(result) {
      if (result) {
        this.payload.id_funcionario = result.id;
        return result.nome;
      }
      else return "";
    },
    procurarFuncionario(result) {
      if (result)
        return result.nome;
      else return "";
    },
    carregarFuncionario(input) {
      if (input.length > 1)
        return this.fuseSearch.search(input);
      else {
        this.payload.id_funcionario = "";
        return this.funcionarios;
      }
    },
    listarDepartamentos() {
      let th = this;
      this.block.departamento = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
      };
      this.axios
        .post("/api/departamento/listarDepartamentos", bodyFormData)
        .then((response) => {
          th.block.departamento = false;
          th.departamentos = response.data.data.dados;
        })
        .catch((err) => {
          th.block.departamento = false;
          console.log(err);
        });
    },
    listarPostos() {
      this.block.posto = true;
      let th = this;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
      };
      this.axios
        .post("/api/empregador/listarTodosEmpregadores2", bodyFormData)
        .then((response) => {
          th.block.posto = false;
          th.postos = response.data.data.dados;
        })
        .catch((err) => {
          console.log(err);
          th.block.posto = false;
        });
    },
    listarFuncionarios() {
      let th = this;
      this.block.funcionario = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        idUsuario: ""
      };

      if (this.dadosUsuario) {
        bodyFormData.idUsuario = this.dadosUsuario.id;
      }

      this.axios
        .post("/api/empregado/listarEmpregados2", bodyFormData)
        .then((response) => {
          th.block.funcionario = false;
          th.funcionarios = response.data.data.dados;

          th.fuseSearch = new Fuse(th.funcionarios, {
            keys: ["nome", "cpf"],
            threshold: 0.3,
          });
        })
        .catch((err) => {
          th.block.funcionario = false;
        });
    },
    validarCampos(checarEmail = false) {
      let status = true;

      const validarEmail = () => {
        let emails = this.emails.split(';').map(e => String(e).trim());
        let result = true;
        const regex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
        //vaidando email
        if (emails.length) {
          for (let i = 0; i < emails.length; i++) {
            if (!regex.test(emails[i])) {
              result = false;
            }
          }
        } else {
          result = false;
        }
        if (result) {
          this.payload.emails = emails;
        }
        return result;
      }

      if (checarEmail) {
        // validando emails
        if (!validarEmail()) {
          status = false;
          this.block.emails = true;
        } else {
          this.block.emails = false;
        }
      }

      // validando datas
      if (this.payload.data_final == "") {
        this.block.data_final = true;
        status = false;
      } else {
        this.block.data_final = false;
      }

      if (this.payload.data_inicial == "") {
        this.block.data_inicial = true;
        status = false;
      } else {
        this.block.data_inicial = false;
      }

      if (this.payload.id_funcionario == "") {
        const inicio = this.moment(this.payload.data_inicial);
        const inicioMais1Mes = this.moment(inicio).add(1, 'months')
        const fim = this.moment(this.payload.data_final);

        if (fim > inicioMais1Mes) {
          this.block.data_final = true;
          status = false;
          this.showSwal("auto-close", "Erro", "ATENÇÃO: Para a opção TODOS, a geração e visualização em tela tem limite de 1 mês.", "error");
        } else {
          this.block.data_final = false;
        }
      }

      return status;

    },
    pesquisar() {
      if (this.validarCampos(false)) {
        this.payload.setDB = this.$cookies.get("db");
        this.payload.id_empregador = this.$cookies.get("idEmpregador");

        if (this.dadosUsuario) {
          this.payload.idUsuario = this.dadosUsuario.id;
        }

        this.$emit("pesquisar", this.payload);
      }
    },
    imprimir() {
      this.$emit("imprimir", true);
    },
    limparFiltro() {
      // document.querySelector('.autocomplete input').value = "";
      this.payload = {
        data_final: "",
        data_inicial: "",
        id_departamento: "",
        id_posto: "",
        id_funcionario: ""
      }
    }
  }
};
</script>
<style>
.autocomplete-result {
  cursor: default;
  padding: 12px 12px 12px 12px;
  background-image: none;
}

.autocomplete-input {
  height: 38px;
  font-size: 14px;
  border: 1px solid #2b3553;
  border-radius: 5px;
  padding: 12px 12px 12px 12px;
  box-sizing: border-box;
  position: relative;
  line-height: 1.5;
  flex: 1;
  background: none;
}
</style>
